document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("horizontal-index-reviews")) {
    customElements.define(
      "horizontal-index-reviews",
      class IndexReviews extends HTMLElement {
        constructor() {
          super();
          this.is_show_diff_type = $(this).attr("data-is-diff-type");
          this.isShowOppo = $(this).attr("data-is-show-oppo");
          this.isAutoplay = $(this).attr("data-is-autoplay");
          this.el = this.querySelector('.index-reviews-swiper');
          this.swiper_pagination = this.querySelector('.swiper-pagination');
          this.swiper_button_next = this.querySelector('.swiper-button-next');
          this.swiper_button_prev = this.querySelector('.swiper-button-prev');
          this.initIndexReviews();

          console.log(this.isShowOppo);
        }

        initIndexReviews() {
          const that = this;
          let swiperOpts = {
            'loop': true, // 循环模式选项
            'slidesPerView': 1.4,
            'spaceBetween': that.isShowOppo == "true" ? 3 : 12,
            'centeredSlides': true,
            // 'initialSlide': that.isShowOppo == "true" ? 1 : 0,
            'centeredSlidesBounds': true,
            // 如果需要前进后退按钮
            'navigation': {
              'nextEl': that.swiper_button_next,
              'prevEl': that.swiper_button_prev,
            },
            // 如果需要分页器
            'pagination': {
              'el': that.swiper_pagination,
            },
            'breakpoints': {
              750: {
                'slidesPerView': 1.6,
                'spaceBetween': that.isShowOppo == "true" ? 0 : 20,
                'centeredSlides': true,
                // 'initialSlide': that.isShowOppo == "true" ? 1 : 0,
              },
              1280: {
                'slidesPerView': 2.5,
                'spaceBetween': that.isShowOppo == "true" ? 0 : 20,
                'centeredSlides': true,
                // 'initialSlide': that.isShowOppo == "true" ? 3 : 0,
              },
            }
          }

          if(that.isAutoplay){
            // swiperOpts.autoplay = {
            //   disableOnInteraction: false,
            // }
          }
          new Swiper(that.el, swiperOpts);
        }
      }
    );
  }
});
